import React from "react";

export default function DoronCompanion({ isAsleep }) {
  const imagePath = isAsleep
    ? "/images/doron-sleeping.png"
    : "/images/Doron.png";

  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={imagePath}
        alt={isAsleep ? "Doron sleeping" : "Doron"}
        className="w-32 h-auto transition-all duration-500"
      />
      <p className="text-xs text-gray-700 mt-1 italic">
        {isAsleep ? "Zzz... Doron is sleeping!" : "Doron is watching... stay focused!"}
      </p>
    </div>
  );
}
